import gql from "graphql-tag";

export const autoBookingConfigFragment = gql`
  fragment AutoBookingConfigFragment on AutoBookingConfig {
    isEnabled
    storeType
    anyStatusMinutes
    readyStatusMinutes
    collectedStatusMinutes
    courier
  }
`;
